import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IWebInfoPayload, WebInfoType } from "../../../types/api/webInfo";

export async function saveWebInfo(
  data: IWebInfoPayload
): Promise<AxiosResponse<TResponse<IWebInfoPayload>>> {
  return axios.post<TResponse<IWebInfoPayload>>(
    API_ENDPOINTS.WEB_INFO_SAVE,
    data
  );
}

export async function getWebInfoList(): Promise<
  AxiosResponse<TResponse<IWebInfoPayload[]>>
> {
  return axios.get(`${API_ENDPOINTS.WEB_INFO_LIST}`);
}

export async function getWebInfoDetail(
  type: WebInfoType
): Promise<AxiosResponse<TResponse<IWebInfoPayload>>> {
  return axios.get(`${API_ENDPOINTS.WEB_INFO_DETAIL}/${type}`);
}
